export default __webpack_public_path__ + "static/screen_1_04-06aa0e3757e2761efcc810b84d7ab83c.svg";